import {useTranslations} from 'next-intl';


export default function ProductDetailsSizes({ setCurrentSize }) {
  const t = useTranslations('catalog');
  
  const sizes = ["s", "m", "l", "xl", "xxl"];
  return (
    <li>
      <div className="ltn__tagcloud-widget ltn__size-widget clearfix">
        <strong className="alignleft">{t('size')}</strong>
        <ul>
          {sizes?.map((size, idx) => (
              <li key={idx} className="me-2">
                <span className="linkable" onClick={() => setCurrentSize(size)}></span>
              </li>
          ))}
        </ul>
      </div>
    </li>
  );
};
